import { get, post, patch, del } from './client.js';
const base = (wsId) => `/workspaces/${wsId}/reports`;
export const list    = (wsId)           => get(base(wsId));
export const create  = (wsId, dto)      => post(base(wsId), dto);
export const update  = (wsId, id, dto)  => patch(`${base(wsId)}/${id}`, dto);
export const remove  = (wsId, id)       => del(`${base(wsId)}/${id}`);
export const getOne  = (wsId, id)       => get(`${base(wsId)}/${id}`);
export const run     = (wsId, id)       => post(`${base(wsId)}/${id}/run`);
